//@flow
import * as React from 'react';
import { type Assets } from './utils';

export type ProviderContextValue = {
    assets: Assets,
    providerName: ?string
};

export const ProviderContext: React.Context<null | ProviderContextValue> = React.createContext(
    null
);
